import request from 'utils/request';

import { SaveAsMyTemplateRequest } from './template';

export type SaveAsTeamTemplateRequest = SaveAsMyTemplateRequest & {
  owner_id: string;
};

// id represents the created template's id.
type SaveAsTeamTemplateResponse = { status: string; id: string };

const BASE_PATH = '/multipage/teamtemplate';

/**
 * Save an infograph/design as a team template
 * @param {SaveAsTeamTemplateRequest} saveTemplateRequest - Request object for saving the team template.
 * @returns {Promise<SaveAsTeamTemplateResponse>} - Resolves to the response after attempting to save the team template.
 */
export const saveAsTeamTemplate = async (saveTemplateRequest: SaveAsTeamTemplateRequest) => {
  return await request<SaveAsTeamTemplateResponse>(`${BASE_PATH}/create`, {
    method: 'POST',
    body: JSON.stringify(saveTemplateRequest),
  });
};
